/**
 * WalterGO Wissen — Blog Dual-Filter
 * ===================================
 * Client-seitiger Type+Category-Filter. Vanilla JS.
 * Läuft auf blog.beitrag-Template.
 *
 * Datenquelle: blog-filter-data.liquid → <script data-blog-tags>
 * Filter: Type (alle|beschwerden|ratgeber) + Kategorie (9)
 * URL-Sync: ?type=X&cat=Y
 */
(function () {
  'use strict';

  var grid = document.querySelector('.wissen-grid');
  if (!grid) return;

  /* ============================================================
   * 1. Card-Daten aus data-tags Attribut (Liquid-rendered)
   * ============================================================ */
  var TYPE_FILTERS = ['alle', 'beschwerden', 'ratgeber'];
  var activeType = 'alle';
  var activeCat = 'alle';

  var cards = grid.querySelectorAll('.wg-card');
  var cardData = [];

  cards.forEach(function (card) {
    var raw = card.getAttribute('data-tags') || '';
    var tags = raw ? raw.split(',').map(function(t) { return t.trim().toLowerCase(); }).filter(Boolean) : [];
    cardData.push({ el: card, tags: tags });
  });

  /* Category-Filter dynamisch aus allen vorhandenen Tags bauen */
  var allTags = {};
  cardData.forEach(function(card) {
    card.tags.forEach(function(t) {
      if (t !== 'beschwerden' && t !== 'ratgeber') allTags[t] = true;
    });
  });
  var CAT_FILTERS = ['alle'].concat(Object.keys(allTags).sort());

  /* ============================================================
   * 2. Filter-Logik
   * ============================================================ */
  function matchesFilters(card) {
    if (activeType !== 'alle' && card.tags.indexOf(activeType) < 0) return false;
    if (activeCat !== 'alle' && card.tags.indexOf(activeCat) < 0) return false;
    return true;
  }

  function applyFilters() {
    var visible = 0;
    cardData.forEach(function (card) {
      if (matchesFilters(card)) { card.el.classList.remove('wissen-hidden'); visible++; }
      else { card.el.classList.add('wissen-hidden'); }
    });
    var countEl = document.getElementById('wissen-results-count');
    if (countEl) countEl.textContent = visible + ' von ' + cardData.length + ' Artikeln';
    var emptyEl = document.getElementById('wissen-empty');
    if (emptyEl) emptyEl.classList.toggle('wissen-empty--visible', visible === 0);
  }

  /* ============================================================
   * 4. UI bauen
   * ============================================================ */
  function buildUI() {
    var container = document.createElement('div');
    container.className = 'wissen-filters';

    var typeGroup = document.createElement('div');
    typeGroup.className = 'wissen-filters__group';
    TYPE_FILTERS.forEach(function (type) {
      var btn = document.createElement('button');
      btn.className = 'wissen-filter-pill';
      btn.setAttribute('data-type', type);
      btn.textContent = type.charAt(0).toUpperCase() + type.slice(1);
      if (type === activeType) btn.classList.add('wissen-filter-pill--active');
      typeGroup.appendChild(btn);
    });
    container.appendChild(typeGroup);

    var sep = document.createElement('div');
    sep.className = 'wissen-filters__separator';
    container.appendChild(sep);

    var catGroup = document.createElement('div');
    catGroup.className = 'wissen-filters__group';
    CAT_FILTERS.forEach(function (cat) {
      var btn = document.createElement('button');
      btn.className = 'wissen-filter-pill wissen-filter-pill--cat';
      btn.setAttribute('data-cat', cat);
      btn.textContent = cat === 'alle' ? 'Alle Kategorien' : cat.charAt(0).toUpperCase() + cat.slice(1);
      if (cat === activeCat) btn.classList.add('wissen-filter-pill--active');
      catGroup.appendChild(btn);
    });
    container.appendChild(catGroup);

    grid.parentElement.insertBefore(container, grid);

    container.addEventListener('click', function (e) {
      var pill = e.target.closest('.wissen-filter-pill');
      if (!pill) return;
      var type = pill.getAttribute('data-type');
      var cat = pill.getAttribute('data-cat');
      if (type !== null) {
        activeType = type;
        container.querySelectorAll('[data-type]').forEach(function (b) {
          b.classList.toggle('wissen-filter-pill--active', b.getAttribute('data-type') === activeType);
        });
      }
      if (cat !== null) {
        activeCat = cat;
        container.querySelectorAll('[data-cat]').forEach(function (b) {
          b.classList.toggle('wissen-filter-pill--active', b.getAttribute('data-cat') === activeCat);
        });
      }
      updateURL();
      applyFilters();
    });

    var countEl = document.createElement('div');
    countEl.className = 'wissen-results-count';
    countEl.id = 'wissen-results-count';
    grid.parentElement.insertBefore(countEl, grid);

    var emptyEl = document.createElement('div');
    emptyEl.className = 'wissen-empty';
    emptyEl.id = 'wissen-empty';
    emptyEl.innerHTML = '<div class="wissen-empty__icon">📋</div><div class="wissen-empty__title">Keine Artikel gefunden</div><div class="wissen-empty__text">Passe deine Filter an, um passende Artikel zu finden.</div><button class="wissen-empty__reset">Alle Filter zurücksetzen</button>';
    grid.parentElement.appendChild(emptyEl);

    document.getElementById('wissen-empty').querySelector('.wissen-empty__reset').addEventListener('click', function () {
      activeType = 'alle'; activeCat = 'alle';
      container.querySelectorAll('.wissen-filter-pill').forEach(function (b) { b.classList.remove('wissen-filter-pill--active'); });
      container.querySelector('[data-type="alle"]').classList.add('wissen-filter-pill--active');
      container.querySelector('[data-cat="alle"]').classList.add('wissen-filter-pill--active');
      updateURL(); applyFilters();
    });

    applyFilters();
  }

  /* ============================================================
   * 5. URL-Sync
   * ============================================================ */
  function updateURL() {
    var params = new URLSearchParams(window.location.search);
    if (activeType !== 'alle') params.set('type', activeType); else params.delete('type');
    if (activeCat !== 'alle') params.set('cat', activeCat); else params.delete('cat');
    var newURL = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newURL);
  }

  function readURLParams() {
    var params = new URLSearchParams(window.location.search);
    var typeParam = params.get('type'), catParam = params.get('cat');
    if (typeParam && TYPE_FILTERS.indexOf(typeParam) >= 0) activeType = typeParam;
    if (catParam && CAT_FILTERS.indexOf(catParam) >= 0) activeCat = catParam;
  }

  /* ============================================================
   * 6. Start
   * ============================================================ */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  function init() { readURLParams(); buildUI(); }
})();
